import { memo, useMemo, useState } from "react";
import { Table } from "antd";

const BookingByDate = ({ data }) => {
    const [pageSize, setPageSize] = useState(31);

    const handleChange = (pagination) => {
        setPageSize(pagination.pageSize);
    };

    const percent = (a, b) => {
        if (!b) return "0%";
        return ((a / b) * 100).toFixed(2) + "%";
    };

    const tableData = useMemo(() => {
        if (!data?.result?.length) return [];

        const group = {};

        const totalRow = {
            key: "summary",
            date: "Tổng",
            total_customer: 0,
            total_cancel: 0,
            total_not_come: 0
        };

        for (const item of data.result) {
            const date = item.date;
            const storeId = item.store_id;

            if (!group[date]) {
                group[date] = {
                    key: date,
                    date,
                    total_customer: 0,
                    total_cancel: 0,
                    total_not_come: 0
                };
            }

            group[date].total_customer += Number(item.total_customer || 0);
            group[date].total_cancel += Number(item.total_cancel || 0);
            group[date].total_not_come += Number(item.not_come || 0);

            group[date][`${storeId}_customer`] = Number(item.total_customer || 0);
            group[date][`${storeId}_cancel`] = Number(item.total_cancel || 0);
            group[date][`${storeId}_notcome`] = Number(item.not_come || 0);

            totalRow.total_customer += Number(item.total_customer || 0);
            totalRow.total_cancel += Number(item.total_cancel || 0);
            totalRow.total_not_come += Number(item.not_come || 0);

            totalRow[`${storeId}_customer`] =
                (totalRow[`${storeId}_customer`] || 0) + Number(item.total_customer || 0);

            totalRow[`${storeId}_cancel`] =
                (totalRow[`${storeId}_cancel`] || 0) + Number(item.total_cancel || 0);

            totalRow[`${storeId}_notcome`] =
                (totalRow[`${storeId}_notcome`] || 0) + Number(item.not_come || 0);
        }

        return [
            totalRow,
            ...Object.values(group)
        ];
    }, [data]);

    const columns = useMemo(() => {
        if (!data?.listStore) return [];

        return [
            {
                title: "Ngày",
                dataIndex: "date",
                width: 130,
                fixed: "left"
            },
            {
                title: "Tổng",
                width: 220,
                fixed: "left",
                render: (_, row) => (
                    <>
                        <div><b>{row.total_customer}</b> khách</div>
                        <div style={{ color: "#cf1322" }}>
                            Huỷ: {row.total_cancel} ({percent(row.total_cancel, row.total_customer)})
                        </div>
                        <div style={{ color: "#d48806" }}>
                            Không đến: {row.total_not_come} ({percent(row.total_not_come, row.total_customer)})
                        </div>
                    </>
                )
            },

            ...data.listStore.map((store) => ({
                title: store.name_store,
                width: 220,
                align: "center",
                render: (_, row) => {
                    const total = row[`${store.id}_customer`] || 0;
                    const cancel = row[`${store.id}_cancel`] || 0;
                    const notcome = row[`${store.id}_notcome`] || 0;

                    return (
                        <>
                            <div><b>{total}</b> khách</div>
                            <div style={{ color: "#cf1322" }}>
                                Huỷ: {cancel} ({percent(cancel, total)})
                            </div>
                            <div style={{ color: "#d48806" }}>
                                Không đến: {notcome} ({percent(notcome, total)})
                            </div>
                        </>
                    );
                }
            }))
        ];
    }, [data]);

    return (
        <div className="p-2 bg-white rounded">
            <div className="mb-3 font-semibold text-lg">
                Báo Cáo Booking Theo Ngày
            </div>

            <Table
                rowKey="key"
                columns={columns}
                dataSource={tableData}
                bordered
                size="small"
                scroll={{ x: "max-content", y: 650 }}
                pagination={{
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ["31", "62", "124"]
                }}
                onChange={handleChange}
                rowClassName={(row) =>
                    row.key === "summary"
                        ? "bg-yellow-100 font-bold"
                        : ""
                }
            />
        </div>
    );
};

export default memo(BookingByDate);